"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var RedirectButton_1 = __importDefault(require("./RedirectButton"));

exports.default = RedirectButton_1.default;